import type { FieldRenderProps } from "@tql/ui-components-react/kendo/form";
import { FieldWrapper } from "@tql/ui-components-react/kendo/form";
import { Input } from "@tql/ui-components-react/kendo/inputs";
import { Error, Hint, Label } from "@tql/ui-components-react/kendo/labels";
import type { CSSProperties } from "react";

type FieldRenderPropsInput = {
	label: string;
	id: string;
	disabled: boolean;
	hint: boolean;
	wrapperStyle: CSSProperties | undefined;
	hintDirection: "start" | "end" | undefined;
} & FieldRenderProps;

export const InputField = (fieldRenderProps: FieldRenderPropsInput) => {
	const {
		validationMessage,
		touched,
		label,
		id,
		valid,
		disabled,
		hint,
		wrapperStyle,
		hintDirection,
		// Filter out form-specific props that shouldn't be passed to DOM elements
		// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Destructured to prevent passing to DOM
		handleChange,
		...others
	} = fieldRenderProps;

	const showValidationMessage: string | false | null =
		touched && validationMessage;
	const showHint: boolean = !showValidationMessage && hint;
	const hintId: string = showHint ? `${id}_hint` : "";
	const errorId: string = showValidationMessage ? `${id}_error` : "";
	const labelId: string = label ? `${id}_label` : "";

	return (
		<FieldWrapper style={wrapperStyle}>
			<Label
				className={"k-form-label"}
				editorDisabled={disabled}
				editorId={id}
				editorValid={valid}
				id={labelId}
			>
				{label}
			</Label>
			<div className={"k-form-field-wrap"}>
				<Input
					aria-describedby={`${hintId} ${errorId}`}
					ariaLabelledBy={labelId}
					disabled={disabled}
					id={id}
					valid={valid}
					{...others}
				/>
				{showHint ? (
					<Hint direction={hintDirection} id={hintId}>
						{hint}
					</Hint>
				) : undefined}
				{showValidationMessage ? (
					<Error id={errorId}>{validationMessage}</Error>
				) : undefined}
			</div>
		</FieldWrapper>
	);
};
